import React from "react";
import PostSummaryList from "../PostSummaryList/PostSummaryList.js";

const ExploreComponent = () => {
    return(
        <>
      <PostSummaryList/>
        </>
  );
}
export default ExploreComponent;
